<template>
	  <div class="fx fx-y-center">
			<div class="fx w120 m-r-5" v-if="title"><p class="ask-cont"><i class="ask" v-if="isMust">*</i></p><span class="fx-fill">{{title}}</span></div>
			<div class="fx-fill select-cont">
				<select class="input b-r-5" v-model="currentValue" placeholder="请选择" v-on:change="handleChange" :disabled="false">
					<option :value="item.value" v-for="item in options">{{item.text}}</option>
				</select>
			</div>
		</div>
</template>

<script>
/**
 * z-select
 * @module components/Input
 * @desc 输入框/编辑框
 * @param {String} [title] - 标题
 * @param {Boolean} [isMust] - 是否是必须
 * @param {Array} [{value,text}] - 传数组对象
 * @example
 * <z-select title="类型" :options = "options" v-model="value" isMust = true></z-select>
 */
export default {
  name: 'z-select',
  props: {
    title:{
    	type:String,
			default: ''
    },
    isMust:[Boolean,String],
    options:{
    	type:Array,
    	default:[]
    },
    value: {
    		type:[String,Number],
				default: ''
    },
  },
  computed: {
  	currentValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
	handleChange() {
		this.$emit('handleChange')
	}
	}
};
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	.select-cont{
		position:relative; 
		select{
			position: relative;
			z-index: 2;
			background: transparent;
			height: px-em(72px);
		}
		&:after{
			content: "";
			position: absolute;
			top: 50%;
			right: 10px;
			margin-top: -3px;
			width: 0;
	    height: 0;
	    border-left: 6px solid transparent;
	    border-right: 6px solid transparent;
	    border-top: 8px solid $color-gray;
	    z-index: 1;
		}
	}
</style>


// WEBPACK FOOTER //
// Select.vue?ab7c16ac